export default __webpack_public_path__ + "static/media/478.35573af7.jpg";